
import React, { Component } from 'react'

import {Link} from 'react-router-dom';


// import Loader from "../../loader";
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "./../redux/bindActionCretor";


import PlusIcon from './../icons/plusicon';
import MobileAppList from '../component/Mobile/MobileAppList';



const mapStateToProps = (state) => ({
    notificationId:state.notificationId
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};

class MobileAppNotification extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
        };
        
      }

    clearAllForm = () => {
        this.props.NotificationEditData('')
        this.props.history.push('/Mobile-create')
    }
     
    render() {
        return (
            <React.Fragment>
              {/* <MainLayout history={this.props.history}> */}
                  <div className="right_side_wrapper">
                          <div className="bradcrumb disp_flex d_flex_justify_spacebt d_flex_align_center">
                            <ul className="disp_flex">
                                <li> Mobile app Notifications </li>
                                {/* <li> 
                                    <Link> 
                                        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.75375 0L7.75375 6L1.75375 12L0.25 10.5L4.75375 6L0.25 1.5L1.75375 0Z" fill="white"/>
                                        </svg>
                                        Shorts Program 
                                    </Link> 
                                </li> */}
                            </ul>
                            <Link className="add_page" onClick={(e)=>this.clearAllForm(e)}><PlusIcon /></Link>
                        </div>
                          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                            <p></p>
                            <p className="update_date">
                                {/* Last Update:  */}
                            {/* {hour}:{minutes} {state} - {moment(updateAt).format('MM/DD/YYYY')} Last Updated By: {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname} */}
                            </p>
                        </div>
                        <MobileAppList history={this.props.history}/>
                    </div>    
              {/* </MainLayout> */}
            </React.Fragment>   
        )
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(MobileAppNotification);